import { Component, Inject, OnInit, Input, OnDestroy } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { interval, Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';
import { TimerService } from '../../services/timer.service';

@Component({
  selector: 'app-confirm-inactive-logout',
  templateUrl: './confirm-inactive-logout.component.html',
  styleUrls: ['./confirm-inactive-logout.component.css']
})
export class ConfirmInactiveLogoutComponent implements OnInit, OnDestroy {

  count: number = 60;
  remainingCount: number = 60;
  percentRemaining: number;

  private sub!: Subscription;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmInactiveLogoutComponent>,
    private timerService: TimerService,

  ) {
  }
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  ngOnInit(): void {    
    this.timerService.startTimer(60);
    this.sub = this.timerService.seconds$.subscribe(value => {
      this.remainingCount = value;
      this.percentRemaining = Math.round((value / this.count) * 100);
    })
  }

  continue() {
    this.dialogRef.close('continue');
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  logoff() {
    this.dialogRef.close('logoff');
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
